import { render, staticRenderFns } from "./usersmanagement.vue?vue&type=template&id=676e5682&scoped=true&"
import script from "./usersmanagement.vue?vue&type=script&lang=js&"
export * from "./usersmanagement.vue?vue&type=script&lang=js&"
import style0 from "./usersmanagement.vue?vue&type=style&index=0&id=676e5682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e5682",
  null
  
)

export default component.exports